






















































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
  components: {
  },
})
export default class RankingList extends Vue {

  private title: string = '';
  private list: Array<{name: string , total: number}> = [
    { name: '实例1', total: 10},
    { name: '实例2', total: 10},
    { name: '实例3', total: 10},
    { name: '实例4', total: 10},
  ];

}
